<template>
  <div>
    <div class="fill-line">
      <div class="fill-label">医院等级：</div>
      <div class="fill-cont">
        <el-select v-model="level" placeholder="请选择" style="width: 210px">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
    </div>
    <div class="fill-line">
      <div class="fill-label">邮箱地址：</div>
      <div class="fill-cont">
        <el-input v-model="ild_email" placeholder="请输入邮箱" style="width: 210px">
        </el-input>
      </div>
    </div>
    <div class="fill-line">
      <div class="fill-label">选择省份：</div>
      <div class="fill-cont">
        <el-select
          v-model="provValue"
          placeholder="请选择"
          style="width: 210px"
          @change="changeProv"
        >
          <el-option
            v-for="item in provList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
    </div>
    <div class="fill-line">
      <div class="fill-label">选择城市：</div>
      <div class="fill-cont">
        <el-select
          v-model="cityValue"
          placeholder="请选择"
          style="width: 210px"
          @change="changeCity"
        >
          <el-option
            v-for="item in cityList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
    </div>
    <div class="fill-line">
      <div class="fill-label">医院名称：</div>
      <el-select
        v-model="hospitalName"
        placeholder="请选择医院"
        style="width: 210px"
        :disabled="!cityValue"
        @change="selectHospitalName"
      >
        <el-option
          v-for="item in hospitalList"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <!-- <div class="fill-cont">
        <el-autocomplete
          v-model="hospitalName"
          style="width: 210px"
          :fetch-suggestions="queryHospitalName"
          @select="selectHospitalName"
          placeholder="请输入医院名称"
          :disabled="!hospitalValid"
          clearable
        ></el-autocomplete>
      </div> -->
    </div>
  </div>
</template>
<script>
import { fetchLocation } from "@/api/city";
import { fetchCompleteHospital } from "@/api/hospital";
export default {
  name: "PccmFill",
  data() {
    return {
      options: [
        {
          value: "3",
          label: "3级",
        },
        {
          value: "2",
          label: "2级",
        },
      ],
      level: "3",
      ild_email: "",
      // 省份列表
      provList: [],
      provValue: "",
      // 城市列表
      cityList: [],
      cityValue: "",
      hospitalList: [],
      hospitalName: "",
      hospitalCode: "",
    };
  },
  mounted() {
    fetchLocation({
      parent_code: "0",
    }).then((res) => {
      const { code, data } = res;
      if (code === 0) {
        this.provList = data.reduce((list, el) => {
          list.push({
            label: el.name,
            value: el.code,
          });
          return list;
        }, []);
      }
    });
  },
  computed: {
    hospitalValid() {
      const { cityValue } = this;
      return !!cityValue;
    },
  },
  methods: {
    getHospital() {
      const { cityValue } = this;
      fetchCompleteHospital({
        city_code: cityValue,
        hospital: "",
      }).then((res) => {
        const { code, data } = res;
        if (code === 0) {
          if (data && data.length) {
            this.hospitalList = data.reduce((list, el) => {
              list.push({
                label: el.name,
                value: el.name_code,
              });
              return list;
            }, []);
          }
        }
      });
    },
    queryHospitalName(queryString, cb) {
      console.log(queryString, "queryString");
      const { cityValue } = this;
      fetchCompleteHospital({
        city_code: cityValue,
        hospital: queryString,
      }).then((res) => {
        const { code, data } = res;
        if (code === 0) {
          if (data && data.length) {
            const hospitalList = data.reduce((list, el) => {
              list.push({
                value: el.name,
                ...el,
              });
              return list;
            }, []);
            cb(hospitalList);
          } else {
            cb([]);
          }
        }
      });
    },
    changeCity(val) {
      console.log(val);
      this.getHospital();
    },
    selectHospitalName(name_code) {
      this.hospitalCode = name_code;
    },
    changeProv(val) {
      console.log(val)
      this.cityList = [];
      this.cityValue = "";
      fetchLocation({
        parent_code: val,
      }).then((res) => {
        const { code, data } = res;
        if (code === 0) {
          this.cityList = data.reduce((list, el) => {
            list.push({
              label: el.name,
              value: el.code,
            });
            return list;
          }, []);
        }
      });
    },
    check() {
      const { level, hospitalCode, ild_email, provValue, cityValue } = this;
      if (!level) {
        this.$message({
          message: "请输入选择医院等级",
          type: "error",
        });
        return null;
      }
      if (!hospitalCode) {
        this.$message({
          message: "请输入医院名称",
          type: "error",
        });
        return null;
      }
      if (!ild_email) {
        this.$message({
          message: "请输入邮箱地址",
          type: "error",
        });
        return null;
      }else{  
        const mailReg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/
        
        if (mailReg.test(ild_email)) {
          
        } else {
          this.$message({
            message: "请输入正确的邮箱格式",
            type: "error",
          });
          return null;
        }
        
      }
      if (!provValue) {
        this.$message({
          message: "请选择省份",
          type: "error",
        });
        return null;
      }
      if (!cityValue) {
        this.$message({
          message: "请选择城市",
          type: "error",
        });
        return null;
      }

      return {
        level,
        company_code: hospitalCode,
        email: ild_email, 
        province_code: provValue,
        city_code: cityValue
      };
    },
  },
};
</script>
<style lang="scss" scoped>
.fill-line {
  display: flex;
  align-items: center;
  height: 46px;
  margin: 0 0 18px;
}
.fill-label {
  width: 80px;
  color: #272222;
  font-size: 14px;
}
</style>
